import React, { useContext, useState, useEffect } from "react";
import { Modal, Button, Container } from "semantic-ui-react";
import { RateStoreContext } from "../../stores/RateStore";
import { AppStoreContext } from "../../stores/AppStore";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import { useWindowSize } from "../../hooks/useWindowSize";
import { GLOBAL_MODALS } from "../../stores/modals";
import { trackAction } from "../../tracking";
import OnboardingActions from "../../tracking/actions";
import { useTranslation } from "react-i18next";
export default observer(function ModalTooHigh() {
  const appStore = useContext(AppStoreContext);
  const rateStore = useContext(RateStoreContext);
  const [t] = useTranslation();
  const {
    suggestedNoApprovalNeeded,
    updateRate,
    acceptSuggested,
    isSaving
  } = rateStore;

  useEffect(() => {
    trackAction(OnboardingActions.ModalTooHighDisplay)
  }, [])

  const [lastClicked, setLastClicked] = useState("");

  const updateRateClick = () => {
    trackAction(OnboardingActions.SubmitRateForApproval)
    setLastClicked("approval");
    updateRate().catch(() =>
      runInAction(() => (appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR))
    );
  };

  const acceptSuggestedClick = () => {
    trackAction(OnboardingActions.AcceptSuggestedRate)
    setLastClicked("accept");
    acceptSuggested().catch(() =>
      runInAction(() => (appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR))
    );
  };

  const windowSize = useWindowSize();
  const isWide = windowSize.width > 950;

  let buttonAccept = (
    <Button
      onClick={acceptSuggestedClick}
      loading={isSaving && lastClicked === "accept"}
      disabled={isSaving}
      fluid={!isWide}
      primary
      style={{ marginBottom: isWide ? "" : "1rem" }}
    >
      {t("tooHigh_modal_accept_label")}
    </Button>
  );

  if (appStore.country === 962) {
    buttonAccept = (<></>)
  }

  const buttonSendForApproval = (
    <Button
      onClick={updateRateClick}
      loading={isSaving && lastClicked === "approval"}
      disabled={isSaving}
      fluid={!isWide}
      secondary
    >
      {t("tooHigh_modal_request_approval_label")}
    </Button>
  );

  let buttonLayout;
  if (isWide) {
    buttonLayout = (
      <div style={{ whiteSpace: "nowrap" }}>
        {buttonSendForApproval}
        {buttonAccept}
      </div>
    );
  } else {
    buttonLayout = (
      <div style={{ padding: "0 1.5rem", marginBottom: 20 }}>
        {buttonAccept}
        {buttonSendForApproval}
      </div>
    );
  }

  // Skip Rate Too High Modal for Japanese NM
  if (appStore.country === 962) {
    // updateRate()
    return (null);
  }

  return (
    <Modal
      dimmer="blurring"
      defaultOpen={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      onClose={() => (rateStore.approvalNeeded = false)}
      style={{ maxWidth: 700 }}
    >
      <Modal.Content>
        <Container fluid textAlign="center" style={{ padding: "1rem" }}>
          <p>
            {t("tooHigh_modal_inner_modal_info")}
          </p>
          <p>
            {t("tooHigh_modal_inner_modal_willing", { amount: suggestedNoApprovalNeeded })}
          </p>
          <br />
          {buttonLayout}
        </Container>
      </Modal.Content>
    </Modal>
  );
});
